import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
// import config from "../config/app.json";

Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const token = localStorage.getItem('token')
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Vue.prototype.axios = axios;

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_APIKEY,
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  },
});

// ✅ Auto Hard Refresh When New Version Is Deployed
setInterval(() => {
  fetch('/version.json')
    .then(res => res.json())
    .then(latest => {
      const current = localStorage.getItem('app_version');
      if (!current) {
        localStorage.setItem('app_version', latest.version);
      } else if (String(latest.version) !== current) {
        localStorage.setItem('app_version', latest.version);
        window.location.reload(true); // 🔁 Hard reload
      }
    });
}, 60000); // every 60 seconds

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
